import { portalNotificationsQueryKeys } from './query-keys';
import { PORTAL_NOTIFICATIONS_PAGE_SIZE } from '../services/notifications';
import { pickNotificationId } from '../utils/pickNotificationId';

export const getPortalNotificationsQueryKey = (userRole) =>
  portalNotificationsQueryKeys.infinite(userRole, PORTAL_NOTIFICATIONS_PAGE_SIZE);

export const countUnreadNotificationsInCache = (queryClient, userRole) => {
  const cached = queryClient.getQueryData(getPortalNotificationsQueryKey(userRole));
  const pages = cached?.pages;
  if (!Array.isArray(pages)) {
    return 0;
  }

  return pages.reduce(
    (total, page) => total + (page?.notifications ?? []).filter((item) => !item.read).length,
    0,
  );
};

export const countUnreadChannelNotificationsInCache = (queryClient, userRole, channelId) => {
  const cached = queryClient.getQueryData(getPortalNotificationsQueryKey(userRole));
  const pages = cached?.pages;
  if (!Array.isArray(pages) || !channelId) {
    return 0;
  }

  return pages.reduce((total, page) => {
    const matches = (page?.notifications ?? []).filter(
      (item) => !item.read && item.channelId === channelId,
    );
    return total + matches.length;
  }, 0);
};

export const applyReadToNotificationsCache = (queryClient, userRole, action) => {
  if (!action) return;

  const queryKey = getPortalNotificationsQueryKey(userRole);

  queryClient.setQueryData(queryKey, (current) => {
    if (!current?.pages) return current;

    return {
      ...current,
      pages: current.pages.map((page) => ({
        ...page,
        notifications: (page.notifications ?? []).map((item) => {
          if (action.mode === 'channel') {
            if (item.channelId !== action.channelId || item.read) {
              return item;
            }
            return { ...item, read: true };
          }

          const itemId = pickNotificationId(item);
          if (!itemId || itemId !== action.notificationId || item.read) {
            return item;
          }

          return { ...item, read: true };
        }),
      })),
    };
  });
};

export const applyMarkAllReadToNotificationsCache = (queryClient, userRole) => {
  const queryKey = getPortalNotificationsQueryKey(userRole);

  queryClient.setQueryData(queryKey, (current) => {
    if (!current?.pages) return current;

    return {
      ...current,
      pages: current.pages.map((page) => ({
        ...page,
        notifications: (page.notifications ?? []).map((item) =>
          item.read ? item : { ...item, read: true },
        ),
      })),
    };
  });
};

export const invalidatePortalNotificationsList = (queryClient, userRole) => {
  void queryClient.invalidateQueries({
    queryKey: getPortalNotificationsQueryKey(userRole),
  });
};
